export default __webpack_public_path__ + "static/black-grid-cropped-79c5493c7496d50e1627e9e1db566f6e.jpg";